// ============================================================================
// src/shared/api/postApi.ts
// Helper para eliminar el try/catch repetido de la capa api/ (deuda técnica DT2).
// MISMA lógica y contrato que la versión JS previa — solo se agregó tipado.
// Preserva EXACTAMENTE el contrato de respuesta de ESTE backend:
//
//   - status 1  (éxito):   { status: 1,  message, ...ok(res.data) }
//   - status 0  (negocio): { status: 0,  message, ...fail }
//   - error/red (-1):      { status: -1, message: serverError, ...fail }
//   - otro 2xx sin status 1: undefined  (igual que el patrón legacy)
//
// El token de sesión viaja en el CUERPO (dataPOST.token), no en un header
// (contrato de este backend). Ver docs/PLAN-MIGRACION-TS-Y-TAILWIND-2026-07-21.md
//
// Uso:
//   export const sedesBuscar = (dataPOST) =>
//     postApi("api/sede/BuscarSede", dataPOST, (d) => ({ sedes: d.resultado }), { sedes: [] });
// ============================================================================
import { httpClient } from "./httpClient";
import type { ApiStatus } from "../types/common.types";

/**
 * @param url        ruta del endpoint (p.ej. "api/sede/AgregarSede")
 * @param dataPOST   cuerpo de la petición (incluye token)
 * @param ok         campos extra de la respuesta de ÉXITO
 * @param fail       campos extra (con sus valores vacíos) para status 0 / error
 * @param serverError mensaje del caso -1 (por defecto "Error en el servidor")
 */
export const postApi = async <TOk extends object = {}, TFail extends object = {}>(
  url: string,
  dataPOST: Record<string, unknown>,
  ok: (data: any) => TOk = () => ({} as TOk),
  fail: TFail = {} as TFail,
  serverError = "Error en el servidor",
): Promise<({ status: ApiStatus; message: string } & (TOk | TFail)) | undefined> => {
  try {
    const res = await httpClient.post(url, dataPOST);
    if (res.data.status === 1) {
      return { status: res.data.status, message: res.data.message, ...ok(res.data) };
    }
  } catch (error: any) {
    if (error.response && error.response.data.status === 0) {
      return { status: error.response.data.status, message: error.response.data.message, ...fail };
    }
    return { status: -1, message: serverError, ...fail };
  }
};

export default postApi;
